function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { Image } from "canvas";
import { canvasUtil, grayScaleConverter } from "./imageUtils.js";
import { ImageHash } from "./hash.js";
var HaarWavelet = [1 / Math.SQRT2, 1 / Math.SQRT2];
function waveletFromScalingNumbers(scalingNumbers) {
  var waveletNumbers = scalingNumbers.slice().reverse().map(function (value, index) {
    return index % 2 === 0 ? value : -value;
  });
  return {
    dec: {
      low: scalingNumbers.slice(),
      high: waveletNumbers.slice()
    },
    rec: {
      low: scalingNumbers.slice(),
      high: waveletNumbers.slice()
    }
  };
}
var HaarBasis = waveletFromScalingNumbers(HaarWavelet);
function getBasis(wavelet) {
  if (wavelet === "haar") {
    return HaarBasis;
  }
  throw new Error("Invalid wavelet");
}
function dot(a, b) {
  /* Calculate dot product. */
  return a.reduce(function (dot, value, index) {
    return dot + value * b[index];
  }, 0);
}
function add(a, b) {
  /* Calculate element-wise sum. */
  return a.map(function (value, index) {
    return value + b[index];
  });
}
function mulScalar(scalar, array) {
  return array.map(function (value) {
    return scalar * value;
  });
}
function dwt(data, wavelet) {
  var waveletBasis = getBasis(wavelet);
  var filters = waveletBasis.dec;
  var filterLength = filters.low.length;
  var approx = [];
  var detail = [];

  /* Calculate coefficients. */
  for (var offset = 0; offset + filterLength <= data.length; offset += 2) {
    var values = data.slice(offset, offset + filterLength);
    approx.push(dot(values, filters.low));
    detail.push(dot(values, filters.high));
  }
  return [approx, detail];
}
function idwt(approx, detail, waveletBasis) {
  var filters = waveletBasis.rec;
  var filterLength = filters.low.length;

  /* Initialize transform. */
  var coeffLength = approx.length;
  var pad = new Array(filterLength + (coeffLength - 1) * 2);
  pad.fill(0);

  /* Perform inverse Discrete Wavelet Transform. */
  for (var i = 0; i < coeffLength; i++) {
    var offset = 2 * i;

    /* Calculate values. */
    var values = pad.slice(offset, offset + filterLength);
    values = add(values, mulScalar(approx[i], filters.low));
    values = add(values, mulScalar(detail[i], filters.high));

    /* Update values. */
    pad = pad.slice(0, offset).concat(values).concat(pad.slice(offset + values.length));
  }

  /* Remove padding. */
  return pad.slice(filterLength - 2, pad.length - (filterLength - 2));
}
function wavedec(data, wavelet, level) {
  /*  Initialize transform. */
  var coeffs = [];
  var approx = data.slice();

  /* Transform. */
  for (var i = 0; i < level; i++) {
    /* Perform single level transform. */
    var approxDetail = dwt(approx, wavelet);
    approx = approxDetail[0];

    /* Prepend detail coefficients. */
    coeffs.unshift(approxDetail[1].slice());
  }

  /* Prepend last approximation. */
  coeffs.unshift(approx.slice());
  return coeffs;
}
function waverec(coeffs, wavelet) {
  wavelet = getBasis(wavelet);
  var approx = coeffs[0];
  for (var i = 1; i < coeffs.length; i++) {
    var detail = coeffs[i];
    if (approx.length === detail.length + 1) {
      approx = approx.slice(0, approx.length - 1);
    }
    approx = idwt(approx, detail, wavelet);
  }
  return approx.slice();
}
function median(values) {
  values.sort(function (a, b) {
    return a - b;
  });
  return values[Math.floor(values.length / 2)];
}
function wavedec2(data, wavelet, level) {
  var L = Math.round(Math.sqrt(data.length));
  var rows = new Array(L);
  for (var y = 0; y < L; y++) {
    var row = new Array(L);
    for (var x = 0; x < L; x++) {
      row[x] = data[y * L + x];
    }
    rows[y] = row;
  }
  var cols = new Array(L);
  for (var i = 0; i < L; i++) {
    cols[i] = new Array(L);
  }

  // Rows
  for (var _y = 0; _y < L; _y++) {
    var coeffs = wavedec(rows[_y], "haar", level).flat();
    for (var _x = 0; _x < L; _x++) {
      cols[_x][_y] = coeffs[_x];
    }
  }
  var result = new Array(L * L);

  // Cols
  for (var _x2 = 0; _x2 < L; _x2++) {
    var _coeffs = wavedec(cols[_x2], "haar", level).flat();
    for (var _y2 = 0; _y2 < L; _y2++) {
      result[_y2 * L + _x2] = _coeffs[_y2];
    }
  }
  return result;
}
function unflatten(data, level) {
  var result = [];
  var sizes = [];
  var n = data.length;
  for (var i = 0; i < level; i++) {
    n /= 2;
    sizes.unshift(n);
  }
  sizes.unshift(n);
  var cur = 0;
  for (var _i = 0; _i < sizes.length; _i++) {
    result.push(data.slice(cur, cur + sizes[_i]));
    cur += sizes[_i];
  }
  return result;
}
function waverec2(data, wavelet, level) {
  var L = Math.round(Math.sqrt(data.length));
  var cols = new Array(L);
  for (var x = 0; x < L; x++) {
    var col = new Array(L);
    for (var y = 0; y < L; y++) {
      col[y] = data[y * L + x];
    }
    cols[x] = col;
  }
  var rows = new Array(L);
  for (var i = 0; i < L; i++) {
    rows[i] = new Array(L);
  }

  // Cols
  for (var _x3 = 0; _x3 < L; _x3++) {
    var rec = waverec(unflatten(cols[_x3], level), "haar");
    for (var _y3 = 0; _y3 < L; _y3++) {
      rows[_y3][_x3] = rec[_y3];
    }
  }
  var result = new Array(L * L);

  // Rows
  for (var _y4 = 0; _y4 < L; _y4++) {
    var _rec = waverec(unflatten(rows[_y4], level), "haar");
    for (var _x4 = 0; _x4 < L; _x4++) {
      result[_y4 * L + _x4] = _rec[_x4];
    }
  }
  return result;
}

/**
 * @param image {Image}
 * @param size {number}
 * @param removeMaxHaarLL {boolean}
 */
export function whash(_x5) {
  return _whash.apply(this, arguments);
}
function _whash() {
  _whash = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(image) {
    var size,
      removeMaxHaarLL,
      imageNaturalScale,
      imageSize,
      llMaxLevel,
      level,
      dwtLevel,
      pixels,
      data,
      i,
      coeffs,
      result,
      ll,
      sorted,
      ptr,
      ptrLow,
      _i2,
      j,
      hash,
      med,
      _i3,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          size = _args.length > 1 && _args[1] !== undefined ? _args[1] : 8;
          removeMaxHaarLL = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;
          imageNaturalScale = Math.pow(2, Math.floor(Math.log2(Math.min(image.naturalWidth, image.naturalHeight))));
          imageSize = Math.max(imageNaturalScale, size);
          llMaxLevel = Math.floor(Math.log2(imageSize));
          level = Math.floor(Math.log2(size));
          dwtLevel = llMaxLevel - level;
          _context.t0 = grayScaleConverter;
          _context.next = 10;
          return canvasUtil.resizeImageAndGetData(image, imageSize, imageSize);
        case 10:
          _context.t1 = _context.sent;
          pixels = _context.t0.convert.call(_context.t0, _context.t1);
          data = new Array(pixels.length);
          for (i = 0; i < pixels.length; i++) {
            data[i] = pixels[i] / 255;
          }
          if (removeMaxHaarLL) {
            coeffs = wavedec2(data, "haar", llMaxLevel);
            coeffs[0] = 0;
            data = waverec2(coeffs, "haar", llMaxLevel);
          }
          result = wavedec2(data, "haar", dwtLevel);
          ll = new Float64Array(size * size);
          sorted = new Float64Array(size * size);
          ptr = 0;
          ptrLow = 0;
          for (_i2 = 0; _i2 < size; _i2++) {
            for (j = 0; j < size; j++) {
              ll[ptrLow] = result[ptr];
              sorted[ptrLow] = result[ptr];
              ptr += 1;
              ptrLow += 1;
            }
            ptr += imageSize - size;
          }
          hash = new Uint8ClampedArray(size * size);
          med = median(sorted);
          for (_i3 = 0; _i3 < hash.length; _i3++) {
            hash[_i3] = ll[_i3] > med;
          }
          return _context.abrupt("return", new ImageHash(hash));
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _whash.apply(this, arguments);
}